import React, { useState } from 'react'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { SaveGenerateRefrenceCodes } from './ActionCreator';
import Loader from '../../../../../presentationals/Loader/Loader.component'
import Popup from '../../../../../presentationals/Popup/Popup.component'

export default function Add({ handleTab, admin }) {
    const [loader, setLoader] = useState(false)
    const [popup, setPopup] = useState({ show: false, popupStatus: "" })
    const [obj, setObj] = useState({
        employeeName: ""
    })

    const handleInputValues = (e, type) => {
        setObj((prev) => ({
            ...prev,
            [type]: e.target.value
        }))
    }

    const handleSubmitDisabled = () => {
        if (!obj?.employeeName)
            return true;
        return false;
    }

    const handleSave = () => {
        const newobj = { ...obj, "createdBy": admin.emailId };
        setLoader(true)
        SaveGenerateRefrenceCodes(newobj, callback => {
            setLoader(false)
            if (callback == "success") {
                setPopup({ show: true, popupStatus: "Referal Created Successfully" })
                setObj({
                    employeeName: ""
                })
            } else {
                setPopup({ show: true, popupStatus: "Error Creating Referal" })
            }
            removePopup()
        })
    }

    const closePopup = () => {
        setPopup({ show: false, popupStatus: "" })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    return (
        <>
            {
                loader ? <Loader /> : ""
            }
            {
                popup?.show ? <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} /> : ""
            }
            <div className='marketing-main-css'>
                <div className="row">
                    <div className="col-xs-12" style={{ marginTop: '20px' }}>
                        <div className='shadow' style={{ padding: '15px', borderRadius: '6px' }}>
                            <h4 style={{ cursor: 'pointer', display: 'inline-block' }} onClick={() => handleTab("list",{})}> <ArrowBackIosIcon /> Add</h4>
                            <hr style={{ borderTop: '3px solid rgb(199, 200, 201)', color: "rgb(199, 200, 201)", margin: '10px 0 25px 0' }} />

                            <div className="row">
                                <div className="col-sm-3 col-xs-12">
                                    <label htmlFor="">Employee Name</label>
                                    <input className='form-control' value={obj?.employeeName} placeholder='Enter Employee Name' onChange={(e) => handleInputValues(e, "employeeName")} />
                                </div>
                            </div>
                            <div style={{ marginTop: '20px', textAlign: 'center' }}>
                                <button className='btn btn-primary' disabled={handleSubmitDisabled()} onClick={() => handleSave()}>Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
